import "./Home.css";
import PhoneBanner from "../assests/images/phone-banner.png";
import BannerText from "../assests/images/Banner Text.png";
import AboutAnushthan from "./AboutAnushthan";
import OurServices from "./OurServices";
import WhyChooseUs from "./WhyChooseUs";
import OurTeam from "./OurTeam";
import OurPortfolio from "./OurPortfolio";
import ClientWords from "./ClientWords";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import OurAmazingPortfolio from "./OurAmazingPortfolio";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import OurDna from "./OurDna";
import HomeBanner from "../assests/images/revamped/home_banner.png";
import OurClients from "./OurClients";
import ContactUsSection from "./ContactUsSection";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        // Use setTimeout to allow the route to finish loading
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [hash]);

  return (
    <>
      {/* <section className="hero-section-idea-labs">
        <div className="container-fluid h-100">
          <div className="row h-100 align-items-center justify-content-end">
            <div className="col-lg-6 hero-slogan-container">
              <img className="banner-text-img" src={BannerText} alt=""></img>
            </div>
            <div className="hero-phone-image-container p-0">
              <img
                src={PhoneBanner}
                alt="Phone Displaying Website"
                className="hero-phone-image col-6"
              />
            </div>
          </div>
        </div>
        <div className="background-dots dot-1"></div>
        <div className="background-dots dot-2"></div>
      </section> */}
      {/* Hero Section */}
      <section className="hero-section py-5">
        <div className="container">
          <div className="row align-items-center min-vh-75">
            {/* Left Content */}
            <div className="col-lg-6 col-md-12">
              <div className="pe-lg-5">
                <h1
                  className="display-4 fw-bold mb-4"
                  style={{ lineHeight: "1.2" }}
                >
                  The <span style={{ color: "#ffd700" }}>right</span>
                  <br />
                  <span style={{ color: "#ffd700" }}>message</span> never
                  <br />
                  goes to <span style={{ color: "#ffd700" }}>voicemail</span>
                </h1>

                <div className="mb-4">
                  <p
                    className="lead text-muted mb-2"
                    style={{ fontSize: "1.2rem" }}
                  >
                    We craft stories that always get answered.
                  </p>
                  <p className="lead text-muted" style={{ fontSize: "1.2rem" }}>
                    No missed connections, only lasting impressions.
                  </p>
                </div>

                <a
                  href="/contact-us"
                  className="btn btn-lg px-5 py-3 rounded-pill fw-semibold"
                  style={{
                    backgroundColor: "#ffd700",
                    border: "none",
                    color: "#000",
                    fontSize: "1.1rem",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#ffed4e";
                    e.target.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#ffd700";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  Get Started
                </a>
              </div>
            </div>

            {/* Right Content - Phone Booth Image */}
            <div className="col-lg-6 col-md-12 mt-5 mt-lg-0">
              <div className="d-flex justify-content-center justify-content-lg-end">
                <div
                  className="position-relative"
                  style={{
                    width: "800px",
                    height: "600px",
                  }}
                >
                  <img
                    src={HomeBanner}
                    alt="Phone Booth"
                    className="img-fluid"
                    style={{
                      height: "800px",
                      width: "700px",
                      objectFit: "cover",
                      position: "absolute",
                      top: "50px",
                      // bottom: "-30%",
                      left: "0",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AboutAnushthan></AboutAnushthan>
      <OurDna></OurDna>
      <OurServices></OurServices>
      <WhyChooseUs></WhyChooseUs>
      <OurClients></OurClients>
      <ContactUsSection></ContactUsSection>
      {/* <OurTeam></OurTeam> */}
      {/* <OurAmazingPortfolio></OurAmazingPortfolio>
      <ClientWords></ClientWords>
      <ContactUs></ContactUs> */}
    </>
  );
};

export default Home;
